/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ExitPartnershipBhActionActionType =
  (typeof ExitPartnershipBhActionActionType)[keyof typeof ExitPartnershipBhActionActionType];

export const ExitPartnershipBhActionActionType = {
  unstamp_inactive_user: 'unstamp_inactive_user',
} as const;
